export enum VideoEventTypes {
  IN = 'I',
  OUT = 'O'
}

export class VideoEntityEvent {
  id: number
  eventId: number
  interactiveAreaId: number
  t: number
  r: number[]
  type: VideoEventTypes

  constructor (videoEntityEvent: VideoEntityEvent) {
    for (const property in videoEntityEvent) {
      this[property] = videoEntityEvent[property]
    }
  }
}
